
import cmBlank from '@/components/cmBlank.vue'
import cmLoadmore from '@/components/cmLoadmore.vue'
import wx from 'weixin-js-sdk';
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Popup from 'vux/src/components/popup/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Radio from 'vux/src/components/radio/index.vue'
import Group from 'vux/src/components/group/index.vue'
import PopupHeader from 'vux/src/components/popup-header/index.vue'


export default {
components: {
cmBlank,cmLoadmore,Popup,Group,PopupHeader,XButton,Radio, wx
},
directives: {
TransferDom
},
data () {
return {
blankShow:false,
loadStatus:false,
pickerStatus:false,
loadmoreText:'正在加载。。。',
busy:false,
wash_code:'',
pageFlag:2,
hasNext:0,
lastId:0,
list:[],
checkAllStatus:false,
allText:'全选',
ids:'',
factorys:[],
factory_id:0,
}
},
created(){
this.config();
this.search();

},
amount(){
},
methods:{
copy(val){
this.$func.copy(val,event);
},
reset(){
this.wash_code = '';
this.list = [];
this.lastId = 0;
this.hasNext = 0;
this.getList();
},
search(){
this.list = [];
this.lastId = 0;
this.hasNext = 0;
this.getList();
},
check(i){
if(this.list[i].checked > 0){
this.list[i].checked = 0;
}else{
this.list[i].checked = 1;
}
},
checkAll(){
this.checkAllStatus = !this.checkAllStatus;
if(this.checkAllStatus){
this.list.forEach((item,index)=>{
item.checked = 1;
})
this.allText = '全不选';
}else{
this.list.forEach((item,index)=>{
item.checked = 0;
})
this.allText = '全选';
}
},
getList(){
let isDate = new Date()
let start = `${isDate.getFullYear()}-${isDate.getMonth() + 1}-${isDate.getDate()}`
this.$api.washCode({wash_code:this.wash_code,type:1,start:start,end:start}).then((res)=>{
if(res){
console.log(res);
if(!this.lastId){
this.blankShow = res.data.length > 0 ? false : true;
}
this.hasNext = res.hasNext;
this.lastId = res.lastId;
res.data.forEach((item)=>{
this.list.push(item);
});
}
})
},
barOrder(code){
this.$router.push({name:'barOrder',params:{code:code}})
},
sendWash(){
this.ids = '';
this.list.forEach((item,index) => {
if(item.checked){
this.ids += item.id+',';
}
});
this.$api.getFactory({}).then((res)=>{
if(res){
this.factorys = res.data.factorys;
console.log(res);
this.pickerStatus = true;
}
})
},
onChange (value) {
this.factory_id = value;
},
submitSendWash () {
if(!this.factory_id){
this.$func.showToast('请选择送洗加工厂');
return false;
}
this.$func.startLoading();
this.$api.sendFactory({checkIds:this.ids,factory_id:this.factory_id}).then((res)=>{
if(res){
this.reset();
this.pickerStatus = false;
this.$func.endLoading();
}
})
},
scanQRCode(key,index){
let that = this;
wx.ready(()=> {
wx.scanQRCode({
needResult: 1,
scanType: ['barCode'],
success: function (res) {
setTimeout(()=>{
that.wash_code = that.$func.parseScanResult(res.resultStr);
that.search();
},300);
}
})
});
wx.error((res)=> {
console.log(res)

})
},
config(){
let url = (window.location.href).split('#');
if(url[0].indexOf('?') != '-1'){
url = url[0].split('?');
}
this.$api.wxSign({url:url[0]}).then((res)=>{
if(res){
wx.config({
debug: false,
appId: res.data.appId,
timestamp: res.data.timestamp,
nonceStr: res.data.nonceStr,
signature:res.data.signature,
jsApiList: [
"scanQRCode"
]
});
}
})
},
}
}



// WEBPACK FOOTER //
// ./src/pages/todayRecordList.vue